export class Yuga {
    CivilDays = 0;
    SynodicMonth = 0;
    Adhimasa = 0;
    Tithi = 0;
    Ksayadina = 0;
    constructor() {

    }

}
